import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPositionsByProjectId } from "../../redux/slices/projectSlice";
import TeamMembers from "./TeamMembers";
import api from "../../utils/apiAuth";

const ProjeDetay = ({ onBack }) => {
  const dispatch = useDispatch();
  const {
    selectedProject: project,
    teamMembers,
    loading,
    error,
  } = useSelector((state) => state.projects);
  const userId = useSelector((state) => state.auth.userId);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [userPosition, setUserPosition] = useState(null);
  const [userPositionError, setUserPositionError] = useState(null);
  const [applyMessage, setApplyMessage] = useState({ message: "", type: "" });
  const [hasJoinedProject, setHasJoinedProject] = useState(false);

  // Kullanıcının pozisyonunu almak için API isteği
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // Kullanıcı pozisyonunu al
        const positionResponse = await api.get(`/users/${userId}`, {
          headers: {
            accept: "*/*",
          },
        });
        setUserPosition(positionResponse.data.data.position.name);

        // Kullanıcının katıldığı projeleri al
        const projectsResponse = await api.get(
          `/projects/userProjects/${userId}`,
          {
            headers: {
              accept: "application/json",
            },
          }
        );
        const joinedProjects = projectsResponse.data.data || [];
        setHasJoinedProject(joinedProjects.length > 0);
        if (joinedProjects.length > 0) {
          setHasJoinedProject(true);
        }
      } catch (err) {
        // console.error("Kullanıcı verileri alınırken hata oluştu:", err);
        setUserPositionError("Kullanıcı verileri alınamadı.");
      }
    };

    if (userId && isAuthenticated) {
      fetchUserData();
    }
  }, [userId, isAuthenticated]);

  // Proje değiştiğinde state'leri sıfırla
  useEffect(() => {
    setSelectedPosition(null);
    setApplyMessage({ message: "", type: "" });
    // hasJoinedProject, fetchUserData ile güncellendiği için burada sıfırlamıyoruz
  }, [project]);

  // Pozisyon Eşleşmesini Kontrol Etme
  const checkPositionMatch = () => {
    if (
      !project?.positions ||
      project.positions.length === 0 ||
      !userPosition
    ) {
      return false;
    }
    const selectedPos = project.positions.find(
      (position) => position._id === selectedPosition
    );
    if (!selectedPos) return false;

    const positionName =
      typeof selectedPos.positionName === "object" &&
      selectedPos.positionName?.name
        ? selectedPos.positionName.name
        : selectedPos.positionName || "";
    return positionName === userPosition;
  };

  const isPositionMatch = checkPositionMatch();

  const handlePositionChange = (positionId) => {
    setSelectedPosition(positionId);
    setApplyMessage({ message: "", type: "" }); // Önceki mesajı sıfırla

    /*// Eğer gerekli veriler henüz gelmediyse işlemi durdur
    if (!userPosition || !project || !project.positions) return;
    const selectedPos = project.positions.find(
      (position) => position._id === positionId
    );

    // Pozisyon eşleşmesini kontrol et ve mesaj göster
    if (selectedPos) {
      const positionName =
        typeof selectedPos.positionName === "object" &&
        selectedPos.positionName?.name
          ? selectedPos.positionName.name
          : selectedPos.positionName || "";

      if (userPosition && positionName !== userPosition) {
        setApplyMessage({
          message: "Seçtiğiniz pozisyon, mevcut pozisyonunuzla uyuşmuyor.",
          type: "error",
        });
      }

     
    }*/
  };

  // Pozisyon Seçimi ve Başvuru İşlemi
  const handleApply = async () => {
    if (selectedPosition) {
      // Önceki mesajı sıfırla
      setApplyMessage({ message: "", type: "" });
      // Eğer kullanıcı zaten bir projeye katılmışsa, mesaj göster ve işlemi durdur
      if (hasJoinedProject) {
        setApplyMessage({
          message: "Katılmış olduğunuz proje bulunmaktadır.",
          type: "error",
        });
        return;
      }
      // Pozisyon eşleşmesini kontrol et
      if (!isPositionMatch) {
        setApplyMessage({
          message: "Seçtiğiniz pozisyon, mevcut pozisyonunuzla uyuşmuyor.",
          type: "error",
        });
        return;
      }
      try {
        const response = await api.post(
          `/positions/${selectedPosition}/apply`,
          {}
        );
        if (response.data.success) {
          setApplyMessage({
            message: "Başvurunuz başarıyla tamamlandı.",
            type: "success",
          });
          setHasJoinedProject(true);
        } else {
          setApplyMessage({
            message: response.data.message || "Başvuru başarısız.",
            type: "error",
          });
          if (
            response.data.message === "Katılmış olduğunuz proje bulunmaktadır."
          ) {
            setHasJoinedProject(true);
          }
        }
      } catch (err) {
        // console.error("Başvuru sırasında hata oluştu:", err);
        const errorMessage =
          err.response?.data?.message || "Başvuru sırasında bir hata oluştu.";
        setApplyMessage({ message: errorMessage, type: "error" });
        if (errorMessage === "Katılmış olduğunuz proje bulunmaktadır.") {
          setHasJoinedProject(true);
        }
      }
    }
  };

  // Açıklama ve URL'yi ayıran fonksiyon
  const extractDescriptionAndUrl = (description) => {
    if (!description) {
      return { text: "Açıklama belirtilmemiş", url: null };
    }

    const urlRegex = /(https?:\/\/[^\s]+)/;
    const match = description.match(urlRegex);
    if (match) {
      const url = match[0]; // Bulunan URL
      const text = description.replace(url, "").trim(); // URL'yi çıkar, kalan metni al
      return { text: text || "Açıklama belirtilmemiş", url };
    }
    return { text: description, url: null };
  };

  // Açıklama ve URL'yi ayır
  const { text, url } = extractDescriptionAndUrl(project.description);

  if (!project) {
    return <p>Proje yükleniyor...</p>;
  }

  if (userPositionError) {
    return <p className="text-red-600">{userPositionError}</p>;
  }

  // Kullanıcı pozisyonu sadece giriş yapmışsa yüklenir, giriş yapmamışsa null kalır
  if (isAuthenticated && !userPosition) {
    return;
  }

  return (
    <div className="detay-container shadow-cardShadow rounded-2xl bg-white w-full mx-auto ">
      {/* Geri Butonu (Sadece mobil görünümde görünecek) */}
      <button
        className="sm:hidden text-green-600 flex items-center gap-2"
        onClick={onBack}
      >
        <img src="/chevron-back.svg" alt="Geri" className="w-5 h-5" />
      </button>
      {/* Başlık ve Proje Türü */}
      <div className="flex flex-col border-none mt-2">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-dark truncate max-w-[70%]">
            {project.title}
          </h2>
          <span className="text-xs bg-lighterGreen text-dark px-2 py-1 rounded-md">
            {project.type === "MOBILE"
              ? "Mobil"
              : project.type === "WEB"
              ? "Web"
              : project.type}
          </span>
        </div>
        {/* Tamamlanma Yüzdesi
        <p className="flex flex-col items-end border-none text-grayy text-xs">
          %{project.progress || 0} tamamlandı.
        </p> */}
        
      </div>

      {/* Proje Hakkında */}
      <div className="flex flex-col gap-2">
        <h4 className="text-dark text-base font-semibold ml-1 mt-4">
          Proje Hakkında
        </h4>
        <div>
          <p className="text-grayy break-words text-sm ml-1">{text}</p>
          {url && (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-green-600 hover:underline mt-1 ml-1 block"
            >
              Proje Sunumu
            </a>
          )}
        </div>
      </div>

      {/* Açık Pozisyonlar & Beklenen Nitelikler */}
      <div className="flex flex-row items-start gap-8 pt-4">
        {/* Açık Pozisyonlar */}
        <div className="w-1/2">
          <h3 className="text-base font-semibold text-dark mb-3">
            Açık Pozisyonlar
          </h3>
          <div className="min-h-[40px]">
            {project.positions && project.positions.length > 0 ? (
              <ul className="text-gray-600">
                {project.positions.map((position, index) => {
                  // positionType'ı Jr/Sr formatına çevir
                  const positionType =
                    position.type === "JUNIOR"
                      ? "Jr"
                      : position.type === "SENIOR"
                      ? "Sr"
                      : "";
                  const positionName =
                    typeof position.positionName === "object" &&
                    position.positionName?.name
                      ? position.positionName.name
                      : position.positionName || "Bilinmeyen Pozisyon";
                  const displayName = positionType
                    ? `${positionType} ${positionName}`
                    : positionName;

                  return (
                    <li key={index} className="flex items-center space-x-2">
                      <input
                        type="radio"
                        name="position"
                        id={`position-${position._id}`}
                        value={position._id}
                        checked={selectedPosition === position._id}
                        onChange={() => handlePositionChange(position._id)}
                        className="custom-radio"
                        disabled={!isAuthenticated}
                      />
                      <label
                        htmlFor={`position-${position._id}`}
                        className="text-sm cursor-pointer"
                      >
                        {displayName}
                      </label>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p className="text-grayy text-sm">
                Şu an açık pozisyon bulunmuyor.
              </p>
            )}
          </div>
        </div>

        {/* Beklenen Nitelikler */}
        <div className="w-1/2">
          <h5 className="text-base font-semibold text-dark mb-3">
            Beklenen Nitelikler
          </h5>
          <div className="min-h-[40px] max-h-[150px] overflow-y-auto scrollbar-projects pr-2">
            {project.positions && project.positions.length > 0 ? (
              selectedPosition ? (
                (() => {
                  // Seçili pozisyonu bul
                  const selectedPos = project.positions.find(
                    (position) => position._id === selectedPosition
                  );
                  // Seçili pozisyonun niteliklerini kontrol et
                  return Array.isArray(selectedPos?.expectations) &&
                    selectedPos.expectations.length > 0 ? (
                    <ul className="list-disc list-inside text-sm text-grayy mt-1">
                      {selectedPos.expectations.map((expectation, expIndex) => (
                        <li key={`exp-${expIndex}`} className="text-gray-600">
                          {typeof expectation === "object"
                            ? expectation.name
                            : expectation}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-grayy text-sm">Nitelik belirtilmemiş</p>
                  );
                })()
              ) : (
                <p className="text-grayy text-sm">Lütfen bir pozisyon seçin</p>
              )
            ) : (
              <p className="text-grayy">-</p>
            )}
          </div>
        </div>
      </div>

      {/* Proje Ekibi - TeamMembers bileşenini kullanıyoruz */}
      <TeamMembers team={teamMembers} />

      <div className="flex flex-col border-none items-end">
        {/* Projeye Katıl Butonu - Sadece giriş yapmışsa görünecek */}
        {isAuthenticated && project.positions?.length > 0 && (
          <div className="flex flex-col border-none items-end">
            <button
              className="flex justify-center items-center w-[120px] h-[48px] btn-green text-dark text-sm py-2 rounded-md border-none transition"
              disabled={!selectedPosition}
              onClick={handleApply}
            >
              Projeye Katıl
            </button>
            <br />
            {applyMessage.message && (
              <p
                className={`text-sm ${
                  applyMessage.type === "success"
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {applyMessage.message}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjeDetay;
